import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import projectService from '../services/projectService';

// Async thunk — ถ้า data โหลดแล้ว ไม่ยิง API ซ้ำ
export const fetchProjects = createAsyncThunk(
  'projects/fetchProjects',
  async (companyName, { getState }) => {
    const state = getState();
    // ถ้ามีข้อมูลอยู่แล้วและ company เดิม → คืนค่าเดิม ไม่ยิง API ซ้ำ
    if (state.projects.loaded && state.projects.data.length > 0 && state.projects.company === companyName) {
      return state.projects.data;
    }
    const result = await projectService.getProjectsByCompany(companyName);
    return result;
  }
);

// ฟังก์ชันสำหรับบังคับ refresh โครงการ (ใช้ตอนเพิ่ม/แก้โครงการ)
export const refreshProjects = createAsyncThunk(
  'projects/refreshProjects',
  async (companyName) => {
    const result = await projectService.getProjectsByCompany(companyName);
    return result;
  }
);

const projectSlice = createSlice({
  name: 'projects',
  initialState: {
    data: [],
    loading: false,
    loaded: false,
    company: null,
  },
  reducers: {
    clearProjects: (state) => {
      state.data = [];
      state.loaded = false;
      state.company = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchProjects (cached)
      .addCase(fetchProjects.pending, (state) => {
        if (!state.loaded) state.loading = true; // โหลดครั้งแรกเท่านั้น
      })
      .addCase(fetchProjects.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
        state.loaded = true;
        state.company = action.meta.arg; // ✅ Save company to cache
      })
      .addCase(fetchProjects.rejected, (state) => {
        state.loading = false;
      })
      // refreshProjects (force reload)
      .addCase(refreshProjects.pending, (state) => {
        state.loading = true;
      })
      .addCase(refreshProjects.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
        state.loaded = true;
        state.company = action.meta.arg; // ✅ Save company to cache
      })
      .addCase(refreshProjects.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { clearProjects } = projectSlice.actions;
export default projectSlice.reducer;

